import { Model, ModelId } from "../../../common/rest-api/models/model";

export class RouteComment extends Model {
  get modelId(): ModelId {
    throw new Error("Method not implemented.");
  }
  seqNum ?:number;
  comment:string;
displayOrder :number;
}
